{#if type === 'section'}
    <!-- svelte-ignore a11y-no-noninteractive-element-to-interactive-role -->
    <section {id} role="tabpanel" aria-labelledby={labelledBy} class="prom-tabs__content" tabindex="-1">
        {#if preloadContent}
            <EmptyState showLoadingIndicator title={emptyStateTitle} />
        {:else}
            <svelte:element this={headingLevel}>
                {title}
            </svelte:element>
            <slot></slot>
        {/if}
    </section>
{:else}
    <div {id} role="tabpanel" aria-labelledby={labelledBy} class="prom-tabs__content" tabindex="-1">
        {#if preloadContent}
            <EmptyState showLoadingIndicator title={emptyStateTitle} />
        {:else}
            <slot></slot>
        {/if}
    </div>
{/if}

<script>
    import EmptyState from '../../../nodes/EmptyState/v1/EmptyState.svelte';

    /** @type {string} */
    export let id = '';
    /** @type {'h2'|'h3'|'h4'|'h5'|'h6'}*/
    export let headingLevel = 'h3';
    /** @type {string} */
    export let title = '';
    /** @type {string} */
    export let labelledBy = '';
    /** @type {'section'|'container'} */
    export let type = 'section';
    /** @type {string} */
    export let emptyStateTitle = '';
    /** @type {boolean} */
    export let preloadContent = false;
</script>
